export default "__VITE_ASSET__D8mnJ4ka__";